import { 
    ProviderUsageResult,
    AmountUsage
} from '@/lib/types'
import { Model } from '@/lib/types'
import { bigColorfulConsoleLog } from '../request/helpers/big-colorful-console-log'
import { PricingCore } from '@/lib/pricing/pricing-core'







export function calculatePerplexityUsage(responseAPI: any, model: Model): ProviderUsageResult {
    bigColorfulConsoleLog('responseAPI', 'PURPLE')
    console.log('asfasfewfioqfh4908hf', responseAPI)

    const totalUsage = responseAPI.totalUsage || responseAPI.usage
    

    const providerUsage: ProviderUsageResult['providerUsage'] = {
        inputTokens: totalUsage.inputTokens || undefined,
        completionTokens: totalUsage.outputTokens || undefined,
        reasoningTokens: totalUsage.reasoningTokens || undefined,
        outputTokens: totalUsage.outputTokens || undefined,
        inputImages: undefined,
        outputImages: undefined,
    }

    const inputTokens = totalUsage.inputTokens || 0
    const outputTokens = totalUsage.outputTokens || 0

    const calculatedAmountUsage = calculateAmountUsage({
        inputTokens,
        outputTokens,
        model,
    })

    const metadata = { 
        calculatedInputAmount: calculatedAmountUsage.calculatedInputAmount,
        calculatedOutputAmount: calculatedAmountUsage.calculatedOutputAmount,
        calculatedTotalAmount: calculatedAmountUsage.calculatedTotalAmount,
        modelPricing: model.pricing,
        perplexityUsageStats: totalUsage,
    }

    const amountUsage: AmountUsage = {
        inputAmount: calculatedAmountUsage.calculatedInputAmount,
        outputAmount: calculatedAmountUsage.calculatedOutputAmount,
        totalAmount: calculatedAmountUsage.calculatedTotalAmount + (model.pricing.request || 0),
        profitMultiplier: PricingCore.getProfitMultiplier(model),
    }


    console.log('amountUsage', {
        amountUsage,
        providerUsage,
        metadata,
    })

    return {
        amountUsage,
        providerUsage,
        metadata,
    }
}





function calculateAmountUsage({
    inputTokens,
    outputTokens,
    model,
}: {
    inputTokens: number
    outputTokens: number
    model: Model
}) {
    const calculatedInputAmount = model.pricing.input_token ? inputTokens * model.pricing.input_token : 0
    const calculatedOutputAmount = model.pricing.output_token ? outputTokens * model.pricing.output_token : 0   
    
    return {
        calculatedInputAmount,
        calculatedOutputAmount,
        calculatedTotalAmount: calculatedInputAmount + calculatedOutputAmount,
    }
}